import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bufferToString'
})
export class BufferToStringPipe implements PipeTransform {

  transform(value: any): string {
    if (value?.type === 'Buffer' && Array.isArray(value.data)) {
      return String.fromCharCode.apply(null, value.data);
    }
    return value;
  }

}
